import { Component, HostListener, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from 'src/shared/data/data.service';
import { CartService } from '../../../../shared/services/cart.service';


@Component({
  selector: 'app-navbar-style-two',
  templateUrl: './navbar-style-two.component.html',
  styleUrls: ['./navbar-style-two.component.scss']
})
export class NavbarStyleTwoComponent implements OnInit {
  isLoading: boolean = false;
  showCart: boolean = false;
  cartItems: any[] = [];
  cartItemCount: number = 0;
  showCheckout = false;
  orderData: any;
  isScrolled = false;
showProfileMenu: boolean = false;
  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.isScrolled = window.scrollY > 50;
  }


  searchText: string = '';
  selectedCategory: string = '';

  allProducts: any[] = [];
  filteredProducts: any[] = [];

  projectCategories: any[] = [

    {
      id: '',
      name: 'All Items',
      active: true
    }

  ];
  categories: any[] = [];
  showSearchResults = false;
  wishlistService: any;
  wishlistItems: any;
  wishlistItemCount = 0;
  constructor(private fb: FormBuilder,
    public data: DataService,
    private http: HttpClient,
    private cartService: CartService,
    private router: Router,

  ) {

    this.enquiryForm = this.fb.group({
      lead_name: ['', [Validators.required]],
      // contact_phone: ['', [Validators.required,Validators.pattern("^[0-9]{10}$")]],
      contact_phone: ['', [
        Validators.required,
        Validators.pattern('^[3-7][0-9]{7}$')
      ]],
      contact_email: ['', [Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]],
      customer_type: ['', [Validators.required]],
      delivery_location: ['', [Validators.required]],
      scope_of_project: [''],
      created_by: ['1'],
      source: ['10'],
      status: ['1'],
    });
  }

  public enquiryForm!: FormGroup;
  url: string = '';
  currentPlaceholder: string = 'Search here...';
  private currentIndex: number = 0;

  // Interval reference for cleanup
  private placeholderInterval: any;
  private currentPhrase: string = '';

  // Index tracking for phrases
  private currentPhraseIndex: number = 0;

  // Index tracking for characters in current phrase
  private currentCharIndex: number = 0;

  // Whether we're currently typing or erasing
  private isTyping: boolean = true;

  // Interval references for cleanup
  private typingInterval: any;

  // Speeds for typing and erasing (in milliseconds)
  private typingSpeed: number = 100;
  private erasingSpeed: number = 50;
  private pauseBeforeErasing: number = 2000;
  private pauseBeforeTyping: number = 500;

  // Search term
  searchTerm: string = '';

  // Search term
  placeholders: string[] = [
    'Search for Remote Control Cars...',
    'Search for Educational Robots...',
    'Search for Puzzles...',
    'Search for Train Sets...',
    'Search for Mini Drones...',
    'Search for Musical Toys...'
  ];


  ngOnInit(): void {
    this.startTyping();

    // Subscribe to cart service
    this.cartService.cartItems$.subscribe(items => {
      this.cartItems = items;
    });

    this.cartService.cartItemCount$.subscribe(count => {
      this.cartItemCount = count;
    });

    this.getProjectCategories();
    // this.searchProducts();

    this.cartService.wishlistCount$
      .subscribe(count => {

        this.wishlistItemCount = count;

      });


  }



  classApplied = false;
  toggleClass() {
    this.classApplied = !this.classApplied;
  }
  startTyping(): void {
    this.currentPhrase = this.placeholders[this.currentPhraseIndex].replace("Search for ", ""); // Remove "Search for " from the phrases
    this.currentPlaceholder = "Search for "; // Ensure the prefix stays static
    this.animateText();
  }

  animateText(): void {
    if (this.isTyping) {
      // Typing forward
      this.typingInterval = setTimeout(() => {
        this.currentPlaceholder = "Search for " + this.currentPhrase.substring(0, this.currentCharIndex + 1);
        this.currentCharIndex++;

        if (this.currentCharIndex < this.currentPhrase.length) {
          this.animateText();
        } else {
          // Finished typing, pause before erasing
          this.isTyping = false;
          setTimeout(() => {
            this.animateText();
          }, this.pauseBeforeErasing);
        }
      }, this.typingSpeed);
    } else {
      // Erasing
      this.typingInterval = setTimeout(() => {
        this.currentPlaceholder = "Search for " + this.currentPhrase.substring(0, this.currentCharIndex);
        this.currentCharIndex--;

        if (this.currentCharIndex >= 0) {
          this.animateText();
        } else {
          // Finished erasing, move to next phrase
          this.isTyping = true;
          this.currentPhraseIndex = (this.currentPhraseIndex + 1) % this.placeholders.length;
          this.currentPhrase = this.placeholders[this.currentPhraseIndex].replace("Search for ", ""); // Remove prefix for animation

          // Pause before typing next phrase
          setTimeout(() => {
            this.animateText();
          }, this.pauseBeforeTyping);
        }
      }, this.erasingSpeed);
    }
  }
  addlead() {

    this.isLoading = true;
    if (this.enquiryForm.invalid) {
      this.enquiryForm.markAllAsTouched();
      this.isLoading = false;
      return;
    }

    if (this.enquiryForm.valid) {
      const leadData = this.enquiryForm.value;

      this.url = this.data.base_url + 'addlead/';

      const formData = new FormData();

      // Object.keys(leadData).forEach((key) => {
      //     if(leadData[key]!='' && leadData[key]!=undefined)
      //     {
      //       formData.append(key, leadData[key]);
      //     }
      //   });

      Object.keys(leadData).forEach((key) => {
        // ❌ skip unwanted fields
        if (key === 'customer_type' || key === 'delivery_location') {
          return;
        }

        if (leadData[key] != '' && leadData[key] != undefined) {
          formData.append(key, leadData[key]);
        }
      });
      this.http.post(this.url, formData).subscribe({
        next: (response: any) => {
          console.log('Response from server:', response);
          alert('Thanks For Your Enquiry');
          window.location.reload();
        },
        error: (error: any) => {
          this.isLoading = false;
          console.error('Error:', error);

        },
        complete: () => {
          console.log('Request complete');
          this.isLoading = false;
        },
      });
    }

  }

  ngOnDestroy(): void {
    // Clear interval when component is destroyed to prevent memory leaks
    if (this.typingInterval) {
      clearInterval(this.typingInterval);
    }
  }

  // =====================================
  // CART FUNCTIONALITY
  // =====================================

  toggleCart(): void {
    this.showCart = !this.showCart;
  }

  updateCartItems(items: any[]): void {
    this.cartItems = items;
    this.cartItemCount = items.reduce((total, item) => total + item.quantity, 0);
  }


  // -----------------------------------
  // Wishlist Logic
  // -----------------------------------


  updateWishlistItems(items: any[]): void {
    this.wishlistItems = items;
    this.wishlistItemCount = items.length;
  }

  goToWishlist(): void {
    this.router.navigate(['/wishlist']);
  }


  openCheckout(data: any) {
    this.orderData = data;
    this.showCheckout = true;
  }

  isLoggedIn(): boolean {
    return localStorage.getItem('is_logged_in') === 'true';
  }

  getUserName(): string {
    return localStorage.getItem('customer_name') || '';
  }

  logout() {
    localStorage.clear();
    // window.location.reload();

    this.router.navigate(['/']).then(() => {
      window.location.reload();
    });
  }

  customerTypes = [
    { id: 1, value: "Agriculture & Farming" },
    { id: 8, value: "Consulting & Professional Services" },
    { id: 10, value: "Defence & Security" },
    { id: 12, value: "Education & Training" },
    { id: 16, value: "Entertainment & Media" },
    { id: 18, value: "Food & Beverage" },
    { id: 20, value: "Healthcare & Hospitals" },
    { id: 21, value: "Hospitality & Tourism" },
    { id: 23, value: "Insurance" },
    { id: 25, value: "Logistics & Transportation" },
    { id: 28, value: "Oil & Gas" },
    { id: 29, value: "Pharmaceuticals & Life Sciences" },
    { id: 31, value: "Printing & Packaging" },
    { id: 32, value: "Recycling & Waste Management" },
    { id: 33, value: "Retail & Wholesale" },
    { id: 34, value: "Shipping & Marine" },
    { id: 35, value: "Telecommunications" },
    { id: 38, value: "Warehousing & Supply Chain" },
    { id: 39, value: "Wellness & Fitness" },
    { id: 40, value: "Other (Specify)" },
    { id: 7, value: "Real Estate" },
    { id: 19, value: "Government Sector" },
    { id: 3, value: "Facility Management" },
    { id: 2, value: "MEP Contractors" },
    { id: 13, value: "Fit Out Contractors" },
    { id: 14, value: "END User" },
    { id: 4, value: "Banking & Financial Service" },
    { id: 15, value: "Fire Contractor" }
  ];

  goToCart() {
    this.router.navigate(['/cart-section']);
  }

  getProjectCategories(): void {

    this.http.post<any>(

      this.data.base_url + 'category_data/',
      {}

    ).subscribe({

      next: (response) => {

        if (response.status == 1) {

          const categories = response.data.map(
            (item: any) => {

              return {

                id: item.category_id,
                name: item.category_name,
                active: false

              };

            }
          );

          this.projectCategories = [

            {
              id: '',
              name: 'All Items',
              active: true
            },

            ...categories

          ];

        }

      },

      error: (error) => {

        console.log(error);

      }

    });

  }


  searchProducts(): void {

    const payload = {
      category: this.selectedCategory,
      globalsearch: this.searchText
    };

    this.http.post(
      this.data.base_url + 'supplychain/product_data/',
      payload
    ).subscribe((res: any) => {
      this.filteredProducts = res.data;
      this.showSearchResults = true;
    });
  }


  @HostListener('document:click', ['$event'])
  closeSearch(event: any) {
    const clickedInside =
      event.target.closest('.navbar-search-wrapper');

    if (!clickedInside) {
      this.showSearchResults = false;
    }
  }

  openProduct(id: string): void {
    this.router.navigate(
        ['/product-details', id]
    );
}


goToProfileTab(tab: 'profile' | 'addresses' | 'orders' | 'password') {
  this.showProfileMenu = false;
  this.router.navigate(['/user-profile'], { queryParams: { tab } });
}

 getUserImage(): string | null {
     return localStorage.getItem('profile_image') || null;
   }
}
